import { surveyPlaceholderImg } from "assets/images";
import { LoadingButton } from "components/form";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import { getFromLocal } from "config/axiosInstance";
import { useLinkDownloader } from "hooks/useLinkDownloader";
import useShimmer from "hooks/useShrimmer";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import { invoiceDownloaderAPI, invoiceListAPI } from "services/subscription";
import InvoiceShrimmer from "shrimmer/Subscription/InvoiceShrimmer";
import { findSerialNumber } from "utils/commonHelper";
import { formattedDateDMMYYYY } from "utils/dateHelper";
import { toastMessage } from "utils/toastMessageHelper";

const BillingInvoice = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [invoiceList, setInvoiceList] = useState([]);
  const [showShimmer, setShowShimmer] = useShimmer(InvoiceShrimmer);
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;

  // hook handler
  const { isLoading, downloadLinkFile } = useLinkDownloader();
  const { t } = useTranslation();

  // Function for get subscription list
  const getSubscriptionHistoryHandler = async () => {
    try {
      setShowShimmer(true);
      let sendParamsData = {
        token: getFromLocal(),
        limit: limit,
        page: activePage,
      };

      let responseData = await invoiceListAPI(sendParamsData);
      const { data, message = "", status } = responseData;

      console.log(data, "subscription history list api");
      if (status === 200) {
        console.log(data, "data subscription--------->");
        setInvoiceList(data?.subscriptionList || []);
      } else {
        toastMessage(message, "error", "invoiceSubscriptionList");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setShowShimmer(false);
    }
  };

  const getStatusValue = (status) => {
    const statusObject = {
      pending: { status: "Pending", color: "pending" },
      active: { status: "Success", color: "active" },
      cancelled: { status: "Cancelled", color: "cancelled" },
      paused: { status: "Paused", color: "paused" },
      failed: { status: "Failed", color: "failed" },
      expired: { status: "Expired", color: "expired" },
    };

    return statusObject[status] || { status: "---", color: "---" };
  };

  // invloice downloader
  const invoiceDownloader = (subscriptionDetail) => {
    const params = {
      subscriptionId: subscriptionDetail?._id,
      token: getFromLocal(),
    };
    const fileName = `Invoice-${subscriptionDetail?.invoiceNumber}.pdf`;
    downloadLinkFile({
      apiHandler: invoiceDownloaderAPI,
      fileName: fileName,
      getFileFrom: "url",
      params: params,
    });
  };

  useEffect(() => {
    getSubscriptionHistoryHandler();
  }, []);

  return (
    <>
      <div className="billing_plan">
        {/* <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. 
        </p> */}

        <div className="table_wrap">
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">{t(`BILLING_DETAIL.sno`)}</th>
                <th>{t(`BILLING_DETAIL.ID`)}</th>
                <th>{t(`BILLING_DETAIL.subscriptionType`)}</th>
                <th>{t(`BILLING_DETAIL.dateAndTime`)}</th>
                <th className="text-center">{t(`BILLING_DETAIL.amount`)}</th>
                <th className="text-center">{t(`BILLING_DETAIL.status`)}</th>
                <th className="text-center">{t(`BILLING_DETAIL.action`)}</th>
              </tr>
            </thead>
            {showShimmer || (
              <tbody>
                {Array.isArray(invoiceList) && invoiceList?.length ? (
                  invoiceList?.map((invoice, index) => {
                    return (
                      <tr>
                        <td className="text-center">
                          <span className="sr_number">
                            {findSerialNumber(index, activePage, limit)}
                          </span>
                        </td>
                        <td>#{invoice?.invoiceNumber || "---"}</td>
                        <td>{invoice?.planName || "---"}</td>
                        <td>
                          {formattedDateDMMYYYY(invoice?.startDate)} -
                          {formattedDateDMMYYYY(invoice?.endDate)}
                        </td>
                        <td className="text-center">{invoice?.actualAmount}</td>
                        <td className="text-center">
                          <span
                            className={`tag status ${
                              getStatusValue(invoice?.status)?.color
                            }`}
                          >
                            {getStatusValue(invoice?.status)?.status}
                          </span>
                        </td>
                        <td className="text-center">
                          <LoadingButton
                            type="button"
                            className="download_btn"
                            loading={isLoading}
                            onClick={() => invoiceDownloader(invoice)}
                          >
                            <FiDownload />
                          </LoadingButton>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={8}>
                      <NotFoundPlaceHolder
                        className="mySurveyList"
                        title={t(`BILLING_DETAIL.invoiceListNotFound`)}
                        placeHolderImage={surveyPlaceholderImg}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default BillingInvoice;
